var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents_container"},[_c('h2',{staticClass:"title"},[_vm._v("利用規約")]),_c('p',{staticClass:"note"},[_vm._v("Terms of Service")]),_c('div',{staticClass:"consert_inner",domProps:{"innerHTML":_vm._s(_vm.sanitizeText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }